module.exports = __webpack_public_path__ + "img/quickbooks_integration.41e43b6d.svg";